module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Rose3_Side.11eba624.png";